import { apiClient } from '@/api/client'
import type { FeatureFlagsResponse } from './types'

/** GET /portal/admin/api/v2/feature-flags — @permission_required("settings.feature_flags"). */
export async function fetchFeatureFlags(): Promise<FeatureFlagsResponse> {
  const { data } = await apiClient.get<FeatureFlagsResponse>('/portal/admin/api/v2/feature-flags')
  return data
}

/** POST /portal/admin/feature-flags/api/update — same permission as above. */
export async function updateFeatureFlag(key: string, value: boolean): Promise<{ key: string; value: boolean }> {
  const { data } = await apiClient.post<{ key: string; value: boolean }>('/portal/admin/feature-flags/api/update', {
    key,
    value,
  })
  return data
}
